/**
 * Explota contratos (sales_contratos) en objetos tipo factura filtrados por rango de fechas.
 * Misma estructura que las facturas de PAUTA para que el cálculo de comisión use el mismo util.
 */
export const explodarContratosComoFacturas = (contratos, edificiosMap, fechaInicio, fechaFin) => {
  const fechaInicioDate = new Date(fechaInicio);
  const fechaFinDate = new Date(fechaFin);
  const resultado = [];

  (contratos || [])
    .filter((c) => !c.eliminada && c.estatus === "100%")
    .forEach((c) => {
      (c.meses || []).forEach((mesObj) => {
        if (!mesObj.facturafecha) return;
        const fecha = new Date(mesObj.facturafecha);
        if (isNaN(fecha.getTime())) return;
        if (fecha < fechaInicioDate || fecha > fechaFinDate) return;

        // Backward compat: campos por tipo de pantalla
        let pAsc = mesObj.pantallas_ascensores || "";
        let pEsp = mesObj.pantallas_espera || "";
        let pCir = mesObj.pantallas_circulacion || "";
        let pCow = mesObj.pantallas_cowork || "";
        if (!pAsc && !pEsp && !pCir && !pCow && mesObj.edificios_ids) {
          const ids = mesObj.edificios_ids
            .split(",")
            .map((s) => Number(s.trim()))
            .filter(Boolean);
          const asc = [];
          const esp = [];
          const cir = [];
          const cow = [];
          ids.forEach((eid) => {
            const e = edificiosMap[eid];
            if (!e) return;
            if ((Number(e.pantallas) || 0) > 0) asc.push(eid);
            if ((Number(e.espera) || 0) > 0) esp.push(eid);
            if ((Number(e.totems) || 0) > 0) cir.push(eid);
            if ((Number(e.cowork) || 0) > 0) cow.push(eid);
          });
          pAsc = asc.join(",");
          pEsp = esp.join(",");
          pCir = cir.join(",");
          pCow = cow.join(",");
        }

        if (!pAsc && !pEsp && !pCir && !pCow) return;

        const edificiosParticipantes =
          mesObj.edificios_ids ||
          [
            ...new Set(
              [pAsc, pCir, pEsp, pCow]
                .filter(Boolean)
                .flatMap((s) => s.split(","))
                .map((s) => s.trim())
                .filter(Boolean)
            ),
          ].join(",");

        let pantallasTotales = Number(mesObj.pantallas_totales) || 0;
        if (!pantallasTotales) {
          const sumPantallas = (csv, key) =>
            (csv || "")
              .split(",")
              .map((s) => Number(s.trim()))
              .filter(Boolean)
              .reduce((acc, eid) => acc + (Number(edificiosMap[eid]?.[key]) || 0), 0);
          pantallasTotales =
            sumPantallas(pAsc, "pantallas") +
            sumPantallas(pCir, "totems") +
            sumPantallas(pEsp, "espera") +
            sumPantallas(pCow, "cowork");
        }

        resultado.push({
          id: `contrato-${c.id}-${mesObj.mes}`,
          facturanumero: c.display_id || `CT-${c.id}`,
          facturafecha: mesObj.facturafecha,
          facturafechacobro: mesObj.facturafechacobro || null,
          importe: Number(mesObj.importe) || 0,
          client_id: c.client_id,
          moneda_dolar: c.moneda_dolar || false,
          pais: c.pais,
          edificiosparticipantes: edificiosParticipantes,
          pantallastotales: pantallasTotales,
          pantallas_ascensores: pAsc,
          pantallas_espera: pEsp,
          pantallas_circulacion: pCir,
          pantallas_cowork: pCow,
          isBTL: false,
          isContrato: true,
          eliminada: false,
        });
      });
    });

  return resultado;
};
